import BaseProxy from './BaseProxy';

class Quiz extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/quizzes', parameters);
    }

    async checkChoiceQuestion(id = null) {
        return this.submit('get', `/check/choice/question/${id}`);
    }

    async checkPictureQuestion(id = null, params = null) {
        return this.submit('post', `/check/picture/question/${id}`, params);
    }

    async setResult(params = null) {
        return this.submit('post', '/save/result', params);
    }

    async startQuiz(params = null) {
        return this.submit('post', '/start', params);
    }

    async getRightChoiseQuestionAnswer(id) {
        return this.submit('get', `/get/right/choice/question/${id}`);
    }

    async getRightPictureQuestionAnswer(id) {
        return this.submit('get', `/get/right/picture/question/${id}`);
    }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/api/Quiz.js